module.exports = __webpack_public_path__ + "img/9.d7ef6907.jpg";